import React from 'react';
import { IconBack } from './static/style';

function Back(props) {
    return <IconBack onClick={props.onClick} />
}

export default Back;


// WEBPACK FOOTER //
// ./src/lib/components/LessonPath/back.js